import { MODALS } from '~/shared/constants/modals';
import { closeResponsiveModal, openResponsiveModal } from '~/shared/ui/ResponsiveModals';
import { type ShowChecksProps } from '../../ShowChecks';

export const openShowChecksModal = (props: ShowChecksProps) => {
    openResponsiveModal({
        modalId: MODALS.PAYIN_ORDER_CHECKS,
        modal: MODALS.PAYIN_ORDER_CHECKS,
        title: 'Чеки ордера',
        innerProps: {
            ...props,
            onCancel: () => {
                closeResponsiveModal(MODALS.PAYIN_ORDER_CHECKS);
                props.onCancel?.();
            },
        },
    });
};
